import { render, staticRenderFns } from "./OsEmpilhadeirasComponent.vue?vue&type=template&id=c135af2e&"
import script from "./OsEmpilhadeirasComponent.vue?vue&type=script&lang=js&"
export * from "./OsEmpilhadeirasComponent.vue?vue&type=script&lang=js&"
import style0 from "./OsEmpilhadeirasComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports